<template>
    <Header ueberschrift="Modulare Truppausbildung" />
    <div id="mta2-praxis">
        <a href="https://feuerwehr-lernbar.bayern/topics/modulare-truppausbildung" target="_blank">Zu den Praxisaufgaben</a>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'MTA2',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    methods: {
    },
    created() {
    },
    mounted() {
    }
}
</script>

<style lang="scss">
#mta2-praxis{
    margin-top: 45vh !important;
    a{
        text-decoration: none !important;
        color: black;
        font-size: xx-large;
    }
}
</style>